// import {
//   HiOutlineLightBulb,
//   HiOutlineClipboardCheck,
//   HiOutlineHeart,
//   HiOutlineUserGroup,
//   HiOutlineCalendar,
//   HiOutlineLocationMarker,
//   HiOutlineTrendingUp,
//   HiOutlineCash,
//   HiOutlineSupport
// } from 'react-icons/hi';
// import { FiUsers } from 'react-icons/fi'
// import { assets } from '../../data/assests';

// const About = () => {

//   return (
//     <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 py-8">
//       <div className="rounded-lg  p-8 relative">
//         <div className='mr-[-200px] w-[100%] h-[600px] p-3 rounded-[20px] absolute z-[-1] left-[50%] translate-x-[-50%] flex flex-col items-center justify-center' style={
//           {
//             backgroundImage: `url("${assets.about_image}")`,
//             backgroundSize: '100% 100%',
//             boxShadow: '600px 600px 10px 0 rgba(0,0,0,0.7) inset',
//           }
//         }>
//           <h1 className="text-3xl text-center font-bold mb-8 text-white">من نحن</h1>

//           <p className="text-[1.2rem] md:text-[1.6rem] text-white text-center white mb-6 leading-relaxed">
//             تليسكوب منصة إلكترونية مصممة لدعم وتسهيل عملية حجز دروس خصوصية لطلاب التعليم الاساسي في الجمهورية العربية السورية. يهدف الموقع إلى توفير وسيلة سهلة وفعّالة للطلاب وأولياء أمورهم للتواصل مع معلمين مؤهلين، وتنظيم جداول الدروس، والحصول على الدعم الأكاديمي بسهولة.

//           </p>
//         </div>
//         <div className="w-[100%] flex gap-x-3 max-w-none mt-[500px]  flex-col items-center md:flex-row md:items-stretch md:justify-center ">
//           {/* Vision */}
//           <div className="w-[95%] md:w-[30%] bg-primary bg-opacity-5 px-6 py-3 rounded-lg mb-8 hover:translate-y-[-20px] transition-all duration-500 cursor-pointer">
//             <div className="flex items-center justify-center flex-col mb-2">
//               <HiOutlineLightBulb className="w-[50px] h-[50px] text-white mb-2" />
//               <h2 className="text-2xl font-bold text-white">رؤيتنا</h2>
//             </div>
//             <p className="text-white text-justify leading-relaxed text-[1.3rem]">
//               نسعى لأن نكون الجسر الذي يربط بين الطلاب الطموحين والمعلمين المؤهلين، لنساهم في بناء
//               جيل متعلم ومتميز يواكب التطورات التعليمية الحديثة ويحقق أحلامه الأكاديمية.
//             </p>
//           </div>

//           {/* Mission */}
//           <div className="w-[95%] md:w-[30%] bg-secondary bg-opacity-5 px-6 py-3 rounded-lg mb-8 hover:translate-y-[-20px] transition-all duration-500 cursor-pointer">
//             <div className="flex items-center justify-center flex-col mb-2">
//               <HiOutlineHeart className="w-[50px] h-[50px] text-white mb-2" />
//               <h2 className="text-2xl font-bold text-white">مهمتنا</h2>
//             </div>
//             <p className="text-white text-justify leading-relaxed text-[1.3rem]">
//               توفير منصة سهلة وآمنة تمكن الطلاب وأولياء أمورهم من العثور على أفضل المعلمين المؤهلين،
//               وتنظيم جداول الدروس بسهولة، ومتابعة التقدم الأكاديمي في بيئة تعليمية محفزة ومناسبة.
//             </p>
//           </div>

//           {/* Commitment */}
//           <div className="w-[95%] md:w-[30%] bg-accent bg-opacity-5 px-6 py-3 rounded-lg mb-8 hover:translate-y-[-20px] transition-all duration-500 cursor-pointer">
//             <div className="flex items-center justify-center flex-col mb-2">
//               <HiOutlineClipboardCheck className="w-[50px] h-[50px] text-white mb-2" />
//               <h2 className="text-2xl font-bold text-white">التزامنا</h2>
//             </div>
//             <p className="text-white text-justify leading-relaxed text-[1.3rem]">
//               نلتزم بتوفير تجربة تعليمية متميزة تضع الطالب في المقدمة، مع الحرص على جودة التعليم
//               وسلامة البيئة التعليمية. نؤمن بأن التعليم حق لكل طفل، ونعمل جاهدين لجعل الدروس
//               الخصوصية متاحة وفعالة لجميع الطلاب في محافظة حمص.
//             </p>
//           </div>
//         </div>
//       </div>

//       <div className="mb-8">
//         <div className="flex items-center space-x-3 space-x-reverse mb-6">
//           <FiUsers className="w-8 h-8 text-black" />
//           <h2 className="text-2xl font-bold text-gray-800">ما نقدمه</h2>
//         </div>
//         <div className="grid md:grid-cols-2 gap-6">
//           <div className="f bg-gray-50 p-4 rounded-lg hover:bg-white hover:shadow-lg cursor-pointer hover:scale-[1.05] transition-all duration-300">
//             <h3 className="flex items-center gap-2 font-semibold text-gray-800 mb-2">
//               <HiOutlineUserGroup className='w-5 h-5 a' />
//               معلمون مؤهلون
//             </h3>
//             <p className="text-gray-600 text-sm">شبكة واسعة من المعلمين المؤهلين والمعتمدين</p>
//           </div>
//           <div className="f bg-gray-50 p-4 rounded-lg hover:bg-white hover:shadow-lg cursor-pointer hover:scale-[1.05] transition-all duration-300">
//             <h3 className="flex items-center gap-2 font-semibold text-gray-800 mb-2">
//               <HiOutlineCalendar className='w-5 h-5 a' />
//               نظام حجز مرن
//             </h3>
//             <p className="text-gray-600 text-sm">نظام حجز سهل ومرن يناسب جميع الأوقات</p>
//           </div>
//           <div className="f bg-gray-50 p-4 rounded-lg hover:bg-white hover:shadow-lg cursor-pointer hover:scale-[1.05] transition-all duration-300">
//             <h3 className="flex items-center gap-2 font-semibold text-gray-800 mb-2">
//               <HiOutlineLocationMarker className='w-5 h-5 a' />
//               خريطة تفاعلية
//             </h3>
//             <p className="text-gray-600 text-sm">خريطة تفاعلية لإيجاد أقرب المعلمين</p>
//           </div>
//           <div className="f bg-gray-50 p-4 rounded-lg hover:bg-white hover:shadow-lg cursor-pointer hover:scale-[1.05] transition-all duration-300">
//             <h3 className="flex items-center gap-2 font-semibold text-gray-800 mb-2">
//               <HiOutlineTrendingUp className='w-5 h-5 a' />
//               متابعة التقدم
//             </h3>
//             <p className="text-gray-600 text-sm">متابعة دقيقة للتقدم الأكاديمي</p>
//           </div>
//           <div className="f bg-gray-50 p-4 rounded-lg hover:bg-white hover:shadow-lg cursor-pointer hover:scale-[1.05] transition-all duration-300">
//             <h3 className="flex items-center gap-2 font-semibold text-gray-800 mb-2">
//               <HiOutlineCash className='w-5 h-5 a' />
//               أسعار تنافسية
//             </h3>
//             <p className="text-gray-600 text-sm">أسعار تنافسية وشفافة لجميع الخدمات</p>
//           </div>
//           <div className="f bg-gray-50 p-4 rounded-lg hover:bg-white hover:shadow-lg cursor-pointer hover:scale-[1.05] transition-all duration-300">
//             <h3 className="flex items-center gap-2 font-semibold text-gray-800 mb-2">
//               <HiOutlineSupport className='w-5 h-5 a' />
//               دعم فني
//             </h3>
//             <p className="text-gray-600 text-sm">دعم فني متواصل لحل جميع المشاكل</p>
//           </div>
//         </div>
//       </div>
//       {/* Statistics */}
//       <div className="grid md:grid-cols-3 gap-6 mt-12">
//         <div className="text-center p-6 bg-primary bg-opacity-5 rounded-lg">
//           <div className="text-3xl font-bold text-white mb-2">50+</div>
//           <div className="text-white">معلم مؤهل</div>
//         </div>
//         <div className="text-center p-6 bg-secondary bg-opacity-5 rounded-lg">
//           <div className="text-3xl font-bold text-white mb-2">1000+</div>
//           <div className="text-white">طالب مسجل</div>
//         </div>
//         <div className="text-center p-6 bg-accent bg-opacity-5 rounded-lg">
//           <div className="text-3xl font-bold text-white mb-2">5000+</div>
//           <div className="text-white">درس مكتمل</div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default About;




import { 
  FaUserDoctor, 
  FaCalendarDays, 
  FaMapLocationDot, 
  FaChartLine, 
  FaHandshake, 
  FaHeadset 
} from "react-icons/fa6"; 
import { 
  MdOutlineLightbulb, 
  MdOutlineHandshake, 
  MdOutlineHealthAndSafety, 
  MdGroups 
} from "react-icons/md"; 
import { assets } from "../../data/assests";

const About = () => {
  const serviceItems = [
    { icon: FaUserDoctor, title: "نخبة الأطباء", desc: "شبكة واسعة من الأطباء المؤهلين والمعتمدين بخبرة عالمية.", color: "from-blue-400 to-blue-600" },
    { icon: FaCalendarDays, title: "نظام حجز ذكي", desc: "حجز مواعيد متقدم وسهل، يتكيف مع جدولك وجدول الطبيب بكفاءة.", color: "from-purple-400 to-purple-600" },
    { icon: FaMapLocationDot, title: "تحديد مواقع دقيق", desc: "خريطة تفاعلية متقدمة لتحديد أقرب العيادات والأطباء بسهولة ودقة.", color: "from-pink-400 to-pink-600" },
    { icon: FaChartLine, title: "متابعة علاجية متكاملة", desc: "متابعة دقيقة لتقدم العلاج والحالة الصحية بتقارير تفصيلية.", color: "from-yellow-400 to-yellow-600" },
    { icon: FaHandshake, title: "هيكلة أسعار شفافة", desc: "أسعار واضحة ومفصلة لجميع الخدمات الطبية مع أفضل قيمة مقابل الخدمة.", color: "from-indigo-400 to-indigo-600" },
    { icon: FaHeadset, title: "دعم فني وطبي متميز", desc: "فريق دعم متخصص متاح على مدار الساعة لضمان تجربة سلسة وموثوقة.", color: "from-green-400 to-green-600" },
  ];

  const visionMission = [
    { icon: MdOutlineLightbulb, title: "رؤيتنا الطموحة", desc: "نسعى لأن نكون المنصة العالمية الرائدة التي تربط المرضى بأفضل الخبرات الطبية لضمان خدمات صحية عالية الجودة وغير مسبوقة.", color: "from-blue-400 to-blue-600" },
    { icon: MdOutlineHealthAndSafety, title: "مهمتنا الأساسية", desc: "تقديم تجربة حجز مواعيد طبية سلسة وآمنة، ودعم المرضى في رحلة متابعة صحتهم بأحدث التقنيات والمعايير.", color: "from-red-400 to-red-600" },
    { icon: MdOutlineHandshake, title: "التزامنا الراسخ", desc: "نلتزم بتقديم أرقى تجربة حجز مواعيد طبية مع التركيز على الجودة، الابتكار، وراحة المرضى المطلقة.", color: "from-green-400 to-green-600" },
  ];

  return (
    <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 py-12 bg-gray-50">
      
      {/* Header Section */}
      <div className="relative rounded-lg mb-16 overflow-hidden shadow-lg">
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6 bg-gradient-to-r from-blue-700 to-blue-900 opacity-90 rounded-lg">
          <h1 className="text-5xl md:text-6xl font-extrabold text-white drop-shadow-lg mb-4">من نحن</h1>
          <p className="text-lg md:text-2xl text-white max-w-3xl drop-shadow">
            منصة <span className="font-bold">حَكّمني</span> هي منصة إلكترونية رائدة متخصصة في حجز مواعيد الأطباء بكفاءة وسهولة فائقة.
            نمكن المرضى من التواصل مع نخبة الأطباء، تنظيم المواعيد بمرونة، ومتابعة حالتهم الصحية في بيئة رقمية آمنة وموثوقة بمعايير عالمية.
          </p>
        </div>
      </div>

      {/* Vision, Mission, Commitment */}
      <div className="flex flex-col md:flex-row gap-8 mb-12 justify-center">
        {visionMission.map((item, idx) => (
          <div key={idx} className="w-full md:w-1/3 bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition transform hover:-translate-y-3">
            <div className={`w-16 h-16 flex items-center justify-center rounded-full bg-gradient-to-tr ${item.color} text-white text-3xl mb-4 mx-auto`}>
              <item.icon />
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2 text-center">{item.title}</h2>
            <p className="text-gray-600 text-justify">{item.desc}</p>
          </div>
        ))}
      </div>

      {/* Services Section */}
      <div className="mb-12">
        <div className="flex items-center mb-6">
          <MdGroups className="w-8 h-8 text-gray-800 ml-2" /> 
          <h2 className="text-2xl font-bold text-gray-800">خدماتنا المتميزة</h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {serviceItems.map((service, idx) => (
            <div key={idx} className="bg-white p-6 rounded-xl shadow hover:shadow-2xl transition-transform duration-300 hover:scale-105 cursor-pointer text-center">
              <div className={`w-14 h-14 mx-auto mb-4 p-3 rounded-full bg-gradient-to-tr ${service.color} text-white shadow-lg flex items-center justify-center text-2xl`}>
                <service.icon />
              </div>
              <h3 className="font-semibold text-gray-800 mb-2">{service.title}</h3>
              <p className="text-gray-600 text-sm">{service.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Statistics Section */}
      <div className="grid md:grid-cols-3 gap-6 mt-12">
        <div className="text-center p-6 bg-white rounded-xl shadow hover:shadow-2xl transition">
          <div className="text-5xl font-bold text-blue-500 mb-2">500+</div>
          <div className="text-gray-800 font-semibold">نخبة الأطباء</div>
        </div>
        <div className="text-center p-6 bg-white rounded-xl shadow hover:shadow-2xl transition">
          <div className="text-5xl font-bold text-purple-500 mb-2">10,000+</div>
          <div className="text-gray-800 font-semibold">مرضى حول العالم</div>
        </div>
        <div className="text-center p-6 bg-white rounded-xl shadow hover:shadow-2xl transition">
          <div className="text-5xl font-bold text-green-500 mb-2">50,000+</div>
          <div className="text-gray-800 font-semibold">استشارات ناجحة</div>
        </div>
      </div>
    </div>
  );
};

export default About;










